export const getHost = (): string | undefined => {
	if (typeof window === 'undefined') return undefined
	try {
		return window.location.host
	} catch {
		return undefined
	}
}

export const getHostname = (): string | undefined => {
	if (typeof window === 'undefined') return undefined
	try {
		return window.location.hostname
	} catch {
		return undefined
	}
}

